import React, { Component } from 'react';

import { ref, child, get } from "firebase/database";
import { doc, getDoc } from "firebase/firestore";
import { Navigate } from "react-router-dom";

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

import ActivityReport from './ActivityReport'
import AppHeader from './AppHeader';
import AppFooter from './AppFooter';
import AppSidebar from './AppSidebar';
import CirclesSelectorButton from './CirclesSelectorButton';
import EnabledUsersSelectorButton from './EnabledUsersSelectorButton';
import FeedbackReport from './FeedbackReport'
import GoalsReport from './GoalsReport';
import LoadingSpinner from './LoadingSpinner'
import UsersReport from './UsersReport';
import WelcomeForm from './WelcomeForm'

const INITIAL_STATE = {
  dataLoaded: false,
  reportType: 'Users',
  selectedCircles : [],
  enabledUsersOnly: true
};

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  componentWillMount = () => {
    this.checkDataLoaded();
  }

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    this.checkDataLoaded();
  }

  componentWillUnmount() {
  }

  isAdmin = (user, team) => {
    if (user.email === 'antony@lasoohabits.com' || user.email === 'g.kid@icloud.com' || user.email === 'sally@lasoohabits.com' || user.email === 'keith.abbott@adlerianconsulting.com.au' || user.email === 'david.royle@adlerianconsulting.com.au')
      return true; 

    if (!team['team-admin'])
      return false;

    return team['team-admin'].indexOf(user.email) >= 0;
  }

  checkDataLoaded = () => {
    var data = null;
    if (this.props.firebase.user && !this.state.dataLoaded) {
      const dbRef = ref(this.props.firebase.database);

      get(child(dbRef, 'users/' + this.props.firebase.user.uid)).then((snapshot) => {
        data = snapshot.val();

        return getDoc(doc(this.props.firebase.firestore, "teams", data.team));
      })
      .then((teamSnapshot) => {
        if (teamSnapshot.exists()) {

          var team = teamSnapshot.data()

          if (this.isAdmin(this.props.firebase.user, team)) {
            this.setState({
              data: data,
              dataLoaded: true,
              team: team
            });
          }
          else {
            this.setState({
              navigateUrl: "/access-denied"
            });
          }
        }
      })
    }
  }

  renderTabs = () => {
    return (<Tabs>
      <TabList>
        <Tab>Users</Tab>
        <Tab>Habits</Tab>
        <Tab>Activity</Tab>
        <Tab>Feedback</Tab>
      </TabList>

      <TabPanel>
        { !this.state.dataLoaded ? 
          <LoadingSpinner/> :
          <UsersReport team={this.state.data.team} enabledUsersOnly={this.state.enabledUsersOnly} circles={this.state.selectedCircles}/>
      }
      </TabPanel>
      <TabPanel>
        { !this.state.dataLoaded ? 
          <div/> :
          <GoalsReport team={this.state.data.team} enabledUsersOnly={this.state.enabledUsersOnly} circles={this.state.selectedCircles}/>
        }
      </TabPanel>
      <TabPanel>
       { !this.state.dataLoaded ? 
          <div/> :
          <ActivityReport team={this.state.data.team} enabledUsersOnly={this.state.enabledUsersOnly} circles={this.state.selectedCircles}/>
        }
      </TabPanel>
      <TabPanel>
       { !this.state.dataLoaded ? 
          <div/> :
          <FeedbackReport team={this.state.data.team} enabledUsersOnly={this.state.enabledUsersOnly} circles={this.state.selectedCircles}/>
        }
      </TabPanel>
    </Tabs>);
  }

  selectedCirclesChanged = (selectedCircles) => {
    this.setState({
      selectedCircles : selectedCircles
    })
  }

  renderCircleSelectorButton = () => {
    if (this.state.dataLoaded && this.state.team.circles && Object.keys(this.state.team.circles).length > 0)
      return <CirclesSelectorButton team={this.state.team} onChange={this.selectedCirclesChanged}/>
    else 
      return <div/>
  }

  renderEnabledUsersSelectorButton = () => {
    return <EnabledUsersSelectorButton enabledUsersOnly={this.state.enabledUsersOnly} onChange={this.enabledUsersSelectorChanged}/>
  }

  enabledUsersSelectorChanged = () => {
    this.setState({ enabledUsersOnly: !this.state.enabledUsersOnly })
  }

  render = () => {
    var firebase = this.props.firebase;
    var userLoaded = firebase.initialised;
    var user = this.props.firebase.user
    var team = (this.state.team) ? this.state.team : null

    if (this.state.navigateUrl)
      return (<Navigate to={this.state.navigateUrl}  replace={true} />)

    return (
      <div className='App-pageframeOuter'>
        <div className='App-pageframeInner'>
          <AppHeader firebase={firebase} team={team}/>
          <AppSidebar tab="Reports" firebase={firebase}/>
          <div className='App-content'>
            <div className='App-content-column'>
            {
              !userLoaded 
                ?
                <div>
                  
                </div>
                :
              user
                ? <div>
                    { this.renderEnabledUsersSelectorButton() }
                    { this.renderCircleSelectorButton() }
                    { this.renderTabs() }
                   </div>
                : 
                <WelcomeForm/>
            }
           </div>
          </div>

          <AppFooter tab="Reports"/>
        </div>
      </div>
    )
  }
}

export default Home; 

